import Api from "../gd/api/api"
import ModalEventLink from "./link-entity/event-link/event-link"

export default class EventModalsManager {

    viewById(eventId,eventName=null, menu) {
        /*gd.modal.showGeneric({
            className: "modal-event",
            component: require('./event/modal-event-view.jsx'),
            params: {
                this: this,
                eventId: eventId,
                eventName: eventName,
                event: null
            }
        });*/

        /*gd.modal.showV4({
            className: 'modal-event',
            component: require('./event/modal-event-view'),
            params: {
                this        : this,
                eventId     : eventId,
                eventName   : eventName,
                event       : null
            }
        });*/

        // Chto bi route ne viglyadel xrenovo pri otkritii po starinke
        if (!!menu) {
            gd.goTo(`event/${eventId}/${menu}`);
        } else {
            gd.goTo(`event/${eventId}`);
        }
    }

    viewFull(eventId,eventName, eventFull) {
        /*gd.modal.showGeneric({
            className: "modal-event",
            component: require('./event/modal-event-view.jsx'),
            params: {
                this: this,
                eventId: eventId,
                eventName: eventName,
                event: eventFull
            }
        });*/

        /*gd.modal.showV4({
            className: 'modal-event',
            component: require('./event/modal-event-view'),
            params: {
                this        : this,
                eventId     : eventId,
                eventName   : eventName,
                event       : eventFull
            }
        });*/

        gd.goTo('event/'+eventId);
    }

    deleteEvent(event, callback) {
        gd.modals.confirm.deleteByNameWithComment('Event',event.name, null, ()=>{
            if (callback) callback({deleteInProgress: true});
            const request = Api.Events.deleteEvent(event.id);

            request.done(()=>{
                gd.bus.triggerEvent('event-delete');
                gd.modal.hide();
                if (callback) callback();
            });
        });

    }

    eventLink(projectId, callback) {
        gd.modal.showV4({
            className: 'modal-event-link',
            component: ModalEventLink,
            params: {
                projectId,
                onSubmit: (result)=>{
                    if (callback) callback(result)
                    gd.modal.hide()
                },
            }
        })
    }
}
